"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FancyImageLink = exports.ImageLink = void 0;
var react_1 = __importDefault(require("react"));
var react_router_dom_1 = require("react-router-dom");
var styled_components_1 = __importDefault(require("styled-components"));
var fp_1 = require("lodash/fp");
var ImageLink = function (props) {
    var _a, _b;
    var item = props.item, className = props.className, _c = props.onLoad, onLoad = _c === void 0 ? function () { return null; } : _c, onError = props.onError;
    var commonProps = { className: className };
    var basicLink = (0, fp_1.isEmpty)(props.extraProps);
    var img = (react_1.default.createElement("img", { "data-order": item.displayOrder, src: item.imgSrc, alt: item.altText, className: "img img-responsive", onLoad: onLoad, onError: onError, ref: function (input) { return (input === null || input === void 0 ? void 0 : input.complete) && onLoad(); } }));
    if (/^https?:/.test(item.url)) {
        return (react_1.default.createElement("a", __assign({ href: item.url, target: (_a = props.target) !== null && _a !== void 0 ? _a : '_blank', rel: (_b = props.rel) !== null && _b !== void 0 ? _b : 'nofollow noopener noreferrer' }, commonProps), img));
    }
    return (react_1.default.createElement(react_router_dom_1.NavLink, __assign({}, (basicLink ? { to: item.url } : { to: { pathname: item.url, state: props.extraProps } }), { target: props.target }, commonProps), img));
};
exports.ImageLink = ImageLink;
exports.FancyImageLink = (0, styled_components_1.default)(exports.ImageLink)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: block;\n  width: 140px;\n  height: 140px;\n  overflow: hidden;\n\n  .img {\n    object-fit: cover;\n    display: block;\n    min-width: 100%;\n    min-height: 100%;\n  }\n"], ["\n  display: block;\n  width: 140px;\n  height: 140px;\n  overflow: hidden;\n\n  .img {\n    object-fit: cover;\n    display: block;\n    min-width: 100%;\n    min-height: 100%;\n  }\n"])));
exports.default = exports.FancyImageLink;
var templateObject_1;
